import {useAppSelector} from "@/hooks";

export const useBrandsLoadingState = (): number => {
    return useAppSelector(({brands}) => {
        return brands.brandsLoadingState;
    })
}